import { jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const PartialCheckmarkIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    viewBox: "0 0 12 10",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 10),
    strokeWidth: "3",
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0 .1 4",
    children: /*#__PURE__*/jsx("path", {
      d: "m1.5 5 3.1 3L10 1.5"
    })
  });
};

export { PartialCheckmarkIcon };
//# sourceMappingURL=checkmark.partial.js.map
